import React from 'react';
import { Tooltip } from 'react-tooltip';

const tooltipVariants = ['success', 'warning', 'error', 'info', 'light'];

export default function AllTooltips() {
    return (
        <>
            {tooltipVariants.map((variant, idx) => (
                <Tooltip
                    key={idx}
                    id={'tooltip-id-' + variant}
                    variant={variant}
                    className="tooltip-class"
                    clickable={true}
                />
            ))}
        </>
    );
}
